export default {"src":"/_next/static/media/rightArrow.95633d53.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};